"use strict";
var Observable_1 = require('../../Observable');
var switchMapTo_1 = require('../../operator/switchMapTo');
Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
//# sourceMappingURL=switchMapTo.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/switchMapTo.js
 ** module id = 1542
 ** module chunks = 2
 **/